// Maps route paths to their dynamic import functions for prefetching
const routeImports: Record<string, () => Promise<unknown>> = {
  "/": () => import("@/pages/Index"),
  "/login": () => import("@/pages/Login"),
  "/accept-invite": () => import("@/pages/AcceptInvite"),
  "/admin": () => import("@/pages/OwnerAdmin"),
  "/admin/anamneses": () => import("@/pages/AdminAnamneses"),
  "/exercicios": () => import("@/pages/ExerciseLibrary"),
  "/anamnese": () => import("@/pages/AnamneseForm"),
  "/aluno": () => import("@/pages/StudentApp"),
  "/aluno/login": () => import("@/pages/StudentLogin"),
  "/aluno/onboarding": () => import("@/pages/StudentOnboarding"),
  "/aluno/redefinir-senha": () => import("@/pages/StudentResetPassword"),
  "/aluno/historico": () => import("@/pages/StudentHistory"),
  "/aluno/chat": () => import("@/pages/StudentChat"),
  "/aluno/mensagens": () => import("@/pages/StudentMessages"),
  "/aluno/instalar": () => import("@/pages/StudentInstall"),
};

const prefetched = new Set<string>();

/**
 * Prefetch a route's chunk by path. Safe to call multiple times — each path is only fetched once.
 */
export function prefetchRoute(path: string) {
  // Strip query params and hash
  const clean = path.split("?")[0].split("#")[0];

  // Direct match
  if (routeImports[clean] && !prefetched.has(clean)) {
    prefetched.add(clean);
    routeImports[clean]();
    return;
  }

  // Pattern match for dynamic routes like /student/:id or /aluno/treino/:id
  if (clean.startsWith("/student/") && !prefetched.has("/student/:id")) {
    prefetched.add("/student/:id");
    import("@/pages/StudentProfile");
    return;
  }
  if (clean.startsWith("/aluno/treino/") && !prefetched.has("/aluno/treino/:id")) {
    prefetched.add("/aluno/treino/:id");
    import("@/pages/StudentWorkout");
    return;
  }
  if (clean.startsWith("/admin/anamneses/") && clean !== "/admin/anamneses" && !prefetched.has("/admin/anamneses/:id")) {
    prefetched.add("/admin/anamneses/:id");
    import("@/pages/AdminAnamneseDetail");
  }
}
